module.exports = __webpack_public_path__ + "media/images/loghi/lba_logo-41f5b4340309beec47d7bd2c6fccba56.png";